import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "@shared/shared.module";

import { AuthGuard } from "@core/guards/auth.guard";

import { routing } from "./parametrizacao.routing";
import { ParametrizacaoComponent } from "./pages/parametrizacao/parametrizacao.component";

import { RootComponent } from "@modules/parametrizacao/root/root.component";
import { ParametrizacaoService } from "./services/parametrizacao.service";
import { InvasaoSetorCompletoComponent } from './pages/invasao-setor-completo/invasao-setor-completo.component';
import { InvasaoSetorPorCidadeComponent } from './pages/invasao-setor-por-cidade/invasao-setor-por-cidade.component';
import { HistoricoInvasaoComponent } from './pages/historico-invasao/historico-invasao.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    routing,
    SharedModule
  ],
  declarations: [
    ParametrizacaoComponent,
    RootComponent,
    InvasaoSetorCompletoComponent,
    InvasaoSetorPorCidadeComponent,
    HistoricoInvasaoComponent,
  ],
  providers: [AuthGuard, ParametrizacaoService]
})
export class ParametrizacaoModule {}
